import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { SelfAuthUser, ResetUser } from './store/actions';

import './assets/styles/Login.scss';
import WCLogo from './../../assets/images/wc-logo-transparent-w';

function SelfAuth() {
  const authuser = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const [removedExisting, setRemovedExisting] = useState(false);

  useEffect(() => {
    dispatch(ResetUser({}));
    setRemovedExisting(true);
    const token = getToken();
    if (token) {
      dispatch(SelfAuthUser({ token }));
    } else {
      navigate('/auth', { replace: true });
    }
  }, []);

  useEffect(() => {
    if (authuser && removedExisting) {
      if (authuser.error) {
        return navigate('/auth', { replace: true });
      }
      if (authuser.data && authuser.data.token) {
        navigate('/kpi', { replace: true });
      }
    }
  }, [authuser]);

  const getToken = () => {
    return new URLSearchParams(search).get('token');
  };

  return (
    <div className={'login_container'}>
      <WCLogo />
    </div>
  );
}

export default SelfAuth;
